import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PressCategory, } from "../apiPath/api";

export const createPressCategory = createAsyncThunk(
  "pressCategory/createPressCategory",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await PressCategory.createPressCategory(formData);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const getAllPressCategories = createAsyncThunk(
  "pressCategory/getAllPressCategories",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await PressCategory.getAllPressCategories(params);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const deletePressCategory = createAsyncThunk(
  "pressCategory/deletePressCategories",
  async (id, { rejectWithValue }) => {
    try {
      // Adjust API call as per your API utility
      const response = await PressCategory.deletePressCategory(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const undoDeletePressCategory = createAsyncThunk(
  "pressCategory/undoDeletePressCategory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PressCategory.undoDeletePressCategory(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const updatePressCategory = createAsyncThunk(
  "pressCategory/updatePressCategory",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PressCategory.updatePressCategory(id, data);
      return response.data;
    } catch (error) {
      console.error("Update error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update press category"
      );
    }
  }
);

const pressCategorySlice = createSlice({
  name: "pressCategory",
  initialState: {
    loading: false,
    error: null,
    pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
    statusCounts: { all: 0, active: 0, inactive: 0, deleted: 0 },
    search: "",
    status: "all",
    limit: 10,
    page: 1,
    success: false,
    pressCategory: [],
  },

  reducers: {
    resetPressCategoryState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.pressCategory = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPressCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createPressCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.createdField = action.payload;
      })
      .addCase(createPressCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAllPressCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllPressCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.pressCategory = action.payload.data;
        state.pagination = action.payload.pagination;
        state.statusCounts = action.payload.statusCounts;
      })
      .addCase(getAllPressCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deletePressCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePressCategory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletePressCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(undoDeletePressCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(undoDeletePressCategory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(undoDeletePressCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePressCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updatePressCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedField = action.payload;
      })
      .addCase(updatePressCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetPressCategoryState } = pressCategorySlice.actions;
export default pressCategorySlice.reducer;
